/**
 * Central source of truth for all club sponsors / partners.
 * Used on both the Home page and the /bli-sponsor page.
 *
 * To add a new sponsor: append an object to the array.
 * Both pages will pick it up automatically.
 */
export const sponsors = [
  {
    name: 'Anthonstiftelsen',
    url: 'https://anthonstiftelsen.no/',
    logo: 'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/b6mbz2zh_Anthonstiftelsen.jpg',
  },
  {
    name: 'ASKO Oslo AS',
    url: 'https://asko.no/',
    logo: 'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/st0hdxlb_ASKO%20OSLO%20logo_Gror%20Opp.jpg',
  },
  {
    name: 'Comet Sport',
    url: 'https://cometsport.no/',
    logo: 'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/40d2cu7y_Comet%20Sport%20logo.png',
  },
  {
    name: 'Eivind Astrups Allmennyttige Stiftelse',
    url: 'https://www.eastiftelsen.no/',
    logo: 'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/qoxv0o6j_EA_logo_rgb_svart_bla-2.png',
  },
  {
    name: 'Lions Club Oslo-Maud',
    url: 'https://www.lions.no/',
    logo: 'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/mplyl0ce_php57P3Zu.png',
  },
  {
    name: 'Telenor xtra - Norges Fotballforbund',
    url: 'https://www.fotball.no/barn-og-ungdom/telenor-xtra/telenor-xtra-akademi/',
    logo: 'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/j0w3fvb3_Telenorxtra-crest-midblue-solid.png',
  },
];
